import React from 'react';

import {
    Group, Pagination, SegmentedControl,
} from '@mantine/core';

const LIMITS_LABELS = [
    { label: '40', value: '40' },
    { label: '60', value: '60' },
    { label: '100', value: '100' },
];

export default function DataTablePaging({
    page, total, limit, onPageChange, onLimitChange,
}) {
    return (
        <Group position="apart">
            <Pagination page={page} total={total} onChange={onPageChange} size="md" />
            <SegmentedControl
                value={limit}
                onChange={onLimitChange}
                p={0}
                data={LIMITS_LABELS}
            />
        </Group>
    );
}
